'use client';

import * as HeroIcons from '@heroicons/react/24/outline';
import type { ComponentType } from 'react';

type HeroIconComponent = ComponentType<{ className?: string }>;

interface AppIconProps {
  name: string;
  size?: number;
  className?: string;
}

export default function AppIcon({
  name,
  size = 20,
  className,
}: AppIconProps) {
  // Dynamically resolve icon from Heroicons export
  const IconComponent = (HeroIcons as Record<string, HeroIconComponent>)[name];

  if (!IconComponent) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(`[AppIcon] Missing icon mapping: ${name}`);
    }

    // Safe visual fallback (never invisible)
    return (
      <span data-component-id="src/components/ui/AppIcon.tsx:29:6" data-component-path="src/components/ui/AppIcon.tsx" data-component-line="29" data-component-end-line="43" data-component-file="AppIcon.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22%5Bvar%3AclassName%5D%22%2C%22textContent%22%3A%22%E2%97%8F%22%7D"
        className={className}
        style={{
          width: size,
          height: size,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: size * 0.8,
          lineHeight: 1,
        }}
        aria-hidden="true"
      >
        ●
      </span>
    );
  }

  return (
    <IconComponent data-component-id="src/components/ui/AppIcon.tsx:48:4" data-component-path="src/components/ui/AppIcon.tsx" data-component-line="48" data-component-end-line="52" data-component-file="AppIcon.tsx" data-component-name="IconComponent" data-component-content="%7B%22elementName%22%3A%22IconComponent%22%2C%22className%22%3A%22%5Bvar%3AclassName%5D%22%7D"
      className={className}
      style={{ width: size, height: size }}
      aria-hidden="true"
    />
  );
}
